import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navigate } from 'react-router-dom';

const PaperSubmit = () => {
    const [title, setTitle] = useState('');
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');
    const [isRevision, setIsRevision] = useState('false');
    const [parentSubmissionID, setParentSubmissionID] = useState('');
    const [submissions, setSubmissions] = useState([]);
    const [coAuthors, setCoAuthors] = useState([]);
    const [selectedCoAuthors, setSelectedCoAuthors] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadAllowed, setUploadAllowed] = useState(true);

    const API = process.env.REACT_APP_API_BASE_URL;
    //for current paper name
    const [currPaper, setCurrPaper] = useState('');
    const navigate = useNavigate();

    const authorID = localStorage.getItem('AuthorID');
    const platformID = localStorage.getItem('platformID');
    const SubmissionMode = parseInt(localStorage.getItem('SubmissionMode'));

    const [pdfPreview, setPdfPreview] = useState(null); // For preview

    useEffect(() => {
        // Adjust default paper selection based on SubmissionMode
        if (SubmissionMode === 1) {
            setIsRevision('true');
            setMessage('Abstract submission is disabled for this platform.');

            const timer = setTimeout(() => {
                alert("Abstract submission date is over for this platform.");
            }, 1000);

            return () => clearTimeout(timer);
        }
        else if (SubmissionMode === 2) {
            // Full Paper disabled → select Abstract
            setIsRevision('false');
            setMessage('Full Paper submission is disabled for this platform.');
        }
        else if (SubmissionMode === 0) {
            // All disabled
            setIsRevision('');
            setMessage('All submissions are disabled for this platform.');
        }
        else if (SubmissionMode === 3) {
            // All accepted
            setIsRevision('');
            setMessage('All submission types are allowed on this platform.');
        }

    }, [SubmissionMode]);


    useEffect(() => {
        setPdfPreview('/Standard_Format_for_Final_Paper_Submission_IWWA_Convntion_2026.pdf');
        if (authorID && platformID) {
            axios
                .get(`${API}/api/reviewer-decision/submissions/${authorID}/${platformID}`)
                .then(res => {
                    // Sujay 19/6/2025 adding the filter for getting only the submission that have parentSubmissionId is "NULL"
                    const submission = res.data.filter(sub => (
                        sub.parentSubmissionID === null &&
                        sub.Status === 'Pending' && sub.IsReview === 'Reviewed'
                    ));
                    setSubmissions(submission);
                    // console.log('a',res.data)
                })
                .catch(err => console.error(err));

            axios
                .get(`${API}/api/author/authors`)
                .then(res => {
                    const options = res.data
                        .filter(author => author.AuthorID.toString() !== authorID)
                        .map(author => ({
                            value: author.AuthorID,
                            label: author.AuthorName
                        }));
                    setCoAuthors(options);
                })
                .catch(err => console.error(err));
        }
    }, [authorID, platformID]);

    //to display the which paper user now submitting 
    useEffect(() => {
        if (!parentSubmissionID) return;

        const fetchDetails = async () => {
            try {
                const res = await axios.get(
                    `${API}/api/reviewer-decision/get-sub-details/${parentSubmissionID}`
                );

                const cnt = res.data.childCount;
                const isLastReviewed = res.data.isLastReviewed;

                // Determine paper type
                setCurrPaper(cnt === 0 ? "Full Paper" : "Revision");

                // Block upload if previous revision is not reviewed
                if (cnt > 0 && !isLastReviewed) {
                    alert("You cannot upload a new revision until the last one is reviewed.");
                    // You can also set a state to disable upload button:
                    setUploadAllowed(false);
                } else {
                    setUploadAllowed(true);
                }

            } catch (err) {
                console.error(err);
            }
        };

        fetchDetails();
    }, [parentSubmissionID, API]);

    //  chetan 11/06/2025  add this to get coAuthors for revision pape
    const handleGetOrignalPaper = async (submissionID) => {
        try {
            const res = await axios.get(`${API}/api/submission/${submissionID}`);
            const data = res.data;
            // console.log(res.data);

            if (!data) {
                setTitle('');
                setSelectedCoAuthors([]);
                return;
            }

            // Clean the title
            let cleanTitle = data.SubmissionTitle || '';
            cleanTitle = cleanTitle.replace(/_(Abstract|Full_Paper\d*)$/i, '');
            setTitle(cleanTitle);

            // Parse and match co-author IDs
            const coAuthorIdString = data.CoAuthorIDs || '';
            const ids = coAuthorIdString.split(',').map(id => id.trim()).filter(id => id !== '');
            const selected = coAuthors.filter(author => ids.includes(author.value.toString()));
            setSelectedCoAuthors(selected);
        } catch (err) {
            console.error('Error fetching original paper data:', err);
            setTitle('');
            setSelectedCoAuthors([]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');

        if (!file || file.type !== 'application/pdf') {
            setMessage('Only PDF files are allowed');
            return;
        }

        const formData = new FormData();
        formData.append('SubmissionTitle', title);
        formData.append('file', file);
        formData.append('authorID', authorID);
        formData.append('PlatformID', platformID);
        formData.append('isRevision', isRevision);
        if (isRevision === 'true') {
            formData.append('parentSubmissionID', parentSubmissionID);
        }
        if (selectedCoAuthors.length > 0) {
            const coAuthorIdsString = selectedCoAuthors.map(ca => ca.value).join(',');
            formData.append('CoAuthorIDs', coAuthorIdsString);
        }

        const config = {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
                const pct = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setUploadProgress(pct < 95 ? pct : 95); // cap at 95% until confirmed :contentReference[oaicite:1]{index=1}
            },
        };

        try {
            setIsUploading(true);
            const res = await axios.post(`${API}/api/submission/submit`, formData, config);
            setUploadProgress(100);  // only reach true 100% once server confirms :contentReference[oaicite:2]{index=2}
            alert('Paper submitted successfully');
            navigate('/author/dashboard');
            setTitle('');
            setFile(null);
            setIsRevision('false');
            setParentSubmissionID('');
            setSelectedCoAuthors([]);
            setPdfPreview(); // Clear PDF preview after submission
        } catch (err) {
            setMessage(err.response?.data?.message || 'Submission failed');
        } finally {
            setIsUploading(false);
            setTimeout(() => setUploadProgress(0), 500);
        }
    };

    return (
        <div className="container mt-5 ml-2">
            <div className="card shadow-sm p-4">
                <h3 className="page-title mb-4">Submit Your Technical Paper</h3>

                {message && <div className="alert alert-info">{message}</div>}

                <div className="row">
                    {/* Left Side: Form */}
                    <div className="col-md-6">
                        <form onSubmit={handleSubmit}>
                            {/* Paper Type */}
                            <div className="form-group mb-3">
                                <label className="form-label fw-semibold">Do you want to upload?</label><br />

                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name="paperType"
                                        value="false"
                                        checked={isRevision === 'false'}
                                        onChange={(e) => {
                                            setIsRevision(e.target.value);
                                            setTitle('');
                                            setParentSubmissionID('');
                                            setSelectedCoAuthors([]);
                                            setFile(null);
                                            setPdfPreview(null);
                                        }}
                                        disabled={SubmissionMode === 1}
                                    />
                                    <label className="form-check-label">Abstract Paper</label>
                                </div>

                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name="paperType"
                                        value="true"
                                        checked={isRevision === 'true'}
                                        onChange={(e) => {
                                            setIsRevision(e.target.value);
                                            setTitle('');
                                            setParentSubmissionID('');
                                            setSelectedCoAuthors([]);
                                            setFile(null);
                                            setPdfPreview(null);
                                        }}
                                        disabled={SubmissionMode === 2} // Disable Full Paper if SubmissionMode 2 or 3
                                    />
                                    <label className="form-check-label">Full Paper</label>
                                </div>

                                {SubmissionMode === 0 && (
                                    <div className="alert alert-danger mt-3">
                                        All submissions are disabled for this platform.
                                    </div>
                                )}
                            </div>

                            {isRevision === 'true' && (
                                <div className="form-group mb-3">
                                    <label className="form-label">Select Original Paper</label>
                                    <select
                                        className="form-select"
                                        value={parentSubmissionID}
                                        onChange={(e) => {
                                            const id = e.target.value;
                                            setParentSubmissionID(id);

                                            if (isRevision === 'true' && id) {
                                                if (coAuthors.length >= 0) {
                                                    handleGetOrignalPaper(id);
                                                }
                                            }
                                        }}
                                        //disabled={coAuthors.length === 0}
                                        required
                                    >
                                        <option value="">-- Select Original Paper --</option>
                                        {submissions.map(sub => (
                                            <option key={sub.submissionID} value={sub.submissionID}>
                                                {sub.SubmissionTitle}
                                            </option>
                                        ))}
                                    </select>
                                    {currPaper &&
                                        <div className="alert alert-warning fw-bold text-dark mt-4 w-50" role="alert">
                                            Submit {currPaper}
                                        </div>
                                    }
                                </div>
                            )}

                            <div className="form-group mb-3">
                                <label className="form-label">Paper Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    placeholder="Enter your paper title"
                                    required
                                    disabled={isRevision === 'true'} // Prevent editing when it's a revision
                                />
                            </div>

                            <div className="form-group mb-3">
                                <label className="form-label">Select Co-Authors</label>
                                <Select
                                    isMulti
                                    options={coAuthors}
                                    value={selectedCoAuthors}
                                    onChange={isRevision === 'true' ? undefined : setSelectedCoAuthors}
                                    isDisabled={isRevision === 'true'}
                                    placeholder="No co-authors"
                                />
                            </div>

                            <div className="form-group mb-4">
                                <label className="form-label">Upload PDF</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    accept="application/pdf"
                                    onChange={(e) => {
                                        const uploadedFile = e.target.files[0];
                                        setFile(uploadedFile);


                                        // Set PDF preview
                                        if (uploadedFile && uploadedFile.type === 'application/pdf') {
                                            const fileURL = URL.createObjectURL(uploadedFile);
                                            setPdfPreview(fileURL);
                                        } else {
                                            console.log("gudies for paper upload")
                                            setPdfPreview('/Standard_Format_for_Final_Paper_Submission_IWWA_Convntion_2026.pdf'); // fallback to default if wrong file
                                        }
                                    }}

                                    required
                                    disabled={SubmissionMode === 0} // Disable upload if all submissions are disabled
                                />
                                <small className="form-text text-muted">Only PDF files are accepted.</small>
                            </div>

                            {/* 📤 Progress Bar */}
                            {isUploading && (
                                <div className="form-group mb-3">
                                    <label className="form-label">Uploading PDF:</label>
                                    <div className="progress">
                                        <div
                                            className="progress-bar"
                                            role="progressbar"
                                            style={{ width: `${uploadProgress}%` }}
                                            aria-valuenow={uploadProgress}
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        >
                                            {uploadProgress}%
                                        </div>
                                    </div>
                                </div>
                            )}

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isUploading || SubmissionMode === 0 || !uploadAllowed} // <-- added !uploadAllowed
                            >
                                {isUploading ? 'Uploading...' : 'Submit Paper'}
                            </button>

                        </form>
                    </div>

                    {/* Right Side: PDF Preview with Title */}
                    <div className="col-md-6">
                        {pdfPreview && (
                            <div className="border p-2">
                                <h5 className="fw-semibold mb-2">
                                    {title ? title : "Guidance PDF for uploading paper"}
                                </h5>
                                <iframe
                                    src={pdfPreview}
                                    title={title || "Guidance PDF"}
                                    width="100%"
                                    height="600px"
                                    style={{ border: '1px solid #ccc' }}
                                ></iframe>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PaperSubmit;
